import {view, Icon, tokens} from '@sail/ui';
import type {CssProperties} from '@sail/ui';
import {IconAsset} from '@sail/icons/types';
import {Text} from 'src/v2/components/common/Text';

const FOCUS_RING = '0 0 0 4px rgba(50, 151, 211, 0.3)';

type ChipButtonProps = {
  icon: IconAsset;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  css?: CssProperties;
};

export const ChipButton = ({
  icon,
  label,
  onClick,
  disabled = false,
  css,
}: ChipButtonProps) => {
  return (
    <view.button
      onClick={onClick}
      disabled={disabled}
      css={{
        stack: 'x',
        alignY: 'center',
        gap: 'small',
        padding: '8px 12px',
        borderRadius: 'medium',
        border: 'none',
        backgroundColor: 'offset',
        color: 'text',
        fontFamily: 'inherit',
        transition: 'all 250ms ease-in-out',
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        width: 'fit',
        ':hover': !disabled
          ? {
              backgroundColor: tokens.color.neutral[50].toString(),
            }
          : {},
        ':focus': !disabled
          ? {
              outline: 'none',
              boxShadow: FOCUS_RING,
            }
          : {},
        ...css,
      }}
    >
      <Icon
        icon={icon}
        size="small"
        css={{
          color: 'inherit',
        }}
      />
      <Text
        type="captionEmphasized"
        css={{
          color: 'inherit',
        }}
      >
        {label}
      </Text>
    </view.button>
  );
};
